import pushModel from "../../mixin/store/api/pushModel";
import fetchModels from "@/mixin/store/api/fetchModels";
import changeModel from "@/mixin/store/api/changeModel";
import fetchModel from "@/mixin/store/api/fetchModel";

export default {
    actions: {
        pushProductCreateAndPurchase(context, data) {
            return pushModel(context, 'purchases/create_make_purchase', data)
        },
        fetchProductRefunds(context, search) {
            return fetchModels(context, 'product_refunds?order[id]=desc', search.page, 'updateProductRefunds');
        },
        fetchPurchaseRefund(context, id) {
            return fetchModels(context, 'product_refunds?order[id]=desc&purchase.id=' + id, null, 'updateProductRefund');
        },
        fetchPurchase(context, id) {
            return fetchModel(context, 'purchases', id, 'updatePurchase');
        },
        pushPurchaseRefund(context, data) {
            return changeModel(context, 'purchases/' + data.purchaseId + '/refund', data, 'updatePurchase')
        },
    },
    mutations: {
        updateCreatePurchases(state, data) {
            state.purchases = data
        },
        updatePurchase(state, data) {
            state.purchase = data
        },
        updateProductRefunds(state, data) {
            state.productRefunds = data
        },
        updateProductRefund(state, data) {
            state.productRefund = data
        },
    },
    state: {
        purchases: {
            models: [],
            totalItems: 0,
        },
        purchase: {},
        productRefunds: {
            models: [],
            totalItems: 0,
        },
        productRefund: {
            models: [],
            totalItems: 0,
        },
    },
    getters: {
        getCreatePurchases(state) {
            return state.purchases.models
        },
        getPurchase(state) {
            return state.purchase
        },
        getPurchaseDetails(state) {
            return state.purchase
        },
        getProductRefund(state) {
            return state.productRefund.models
        },
        getProductRefunds(state) {
            return state.productRefunds.models
        },
        getProductRefundTotalCount(state) {
            return state.productRefunds.totalItems
        },
    },
}
